import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserVerificationRequest } from '../../requests/user-verification-request';
import { UserService } from '../../services/user/user.service';
import Validation from '../../validations/validations';

@Component({
  selector: 'app-email-verification',
  imports: [ReactiveFormsModule],
  templateUrl: './email-verification.component.html',
  styleUrl: './email-verification.component.scss',
})
export class EmailVerificationComponent implements OnInit {
  username: string = 'User';
  form!: FormGroup;
  error?: string;
  loading: boolean = true;
  verifying: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private destroyRef: DestroyRef
  ) {
    this.form = fb.group(
      {
        password: fb.control('', [
          Validators.required,
          Validators.minLength(8),
        ]),
        confirmPassword: fb.control('', [
          Validators.required,
          Validators.minLength(8),
        ]),
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      }
    );
  }

  ngOnInit(): void {
    this.userService
      .username(this.route.snapshot.paramMap.get('url') || '')
      .subscribe({
        next: (resp) => {
          this.username = resp.username;
          this.loading = false;
        },
        error: (err) => {
          this.router.navigateByUrl('email/verification/fail');
          this.loading = false;
        },
      });
  }

  verify(): void {
    if (this.form.valid) {
      this.verifying = true;

      let request: UserVerificationRequest = {
        url: this.route.snapshot.paramMap.get('url') || '',
        password: this.form.controls['password'].value,
        confirmPassword: this.form.controls['confirmPassword'].value,
      };

      this.userService
        .verifyUser(request)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.router.navigateByUrl('email/verification/success');
            this.verifying = true;
          },
          error: (err: HttpErrorResponse) => {
            this.error = err.error.message;
            this.verifying = false;
          },
        });
    } else {
      this.error =
        'Password must be at least 8 character long and has to match with confirm password.';
    }
  }
}
